/* nc-decline — entrance trigger. Adds .is-in when the section scrolls into view (once).
   Motion is transform-only in CSS, so if this never runs the content is still fully visible.
   Self-contained, per-instance, no globals. */
(function () {
  'use strict';

  function init(root) {
    if (root.__ncDecReady) return;
    root.__ncDecReady = true;

    // Reduced motion: leave content at its visible base state (rings already filled), never animate.
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (!('IntersectionObserver' in window)) { root.classList.add('is-in'); return; }

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          root.classList.add('is-in');
          io.disconnect();
          break;
        }
      }
    }, { threshold: 0.2 });
    io.observe(root);
    root.__ncDecTeardown = function () { io.disconnect(); };
  }

  function boot() {
    document.querySelectorAll('[data-nc-decline]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-decline]') : null;
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target.querySelector ? e.target.querySelector('[data-nc-decline]') : null;
    if (el && typeof el.__ncDecTeardown === 'function') el.__ncDecTeardown();
  });
})();
